import { FC } from "react";
import {
    Box,
    Container,
    Flex,
    Text,
    useBreakpointValue,
    Icon,
} from "@smile2impress/components";
import { UTSLocale } from "@smile2impress/attraction-constants";
import { useUTSLocaleContext } from "context/utsLocaleContext";

import {
    DrSmileLogo,
    DrSmileXImpressLogo,
} from "components/DrSmile/Header/components/DrSmileLogo";

import { DrSmileHeaderProps } from "./types";
import { AttentionSignIcon } from "./components/AttentionIcon";

export const DrSmileHeader: FC<DrSmileHeaderProps> = ({ title }) => {
    const isMobile = useBreakpointValue({
        base: true,
        tablet: true,
        desktop: false,
    });
    const { locale } = useUTSLocaleContext();

    const isDrSmileBrandOnly = [
        UTSLocale.SWEDEN_SE,
        UTSLocale.FRANCE_FR,
        UTSLocale.GERMANY_DE,
        UTSLocale.NL_NL,
        UTSLocale.SPAIN_ES,
        UTSLocale.ITALY_IT,
    ].includes(locale);

    return (
        <>
            <Container
                mb={["4px", "4px", "8px"]}
                px={["24px", "24px", 0]}
                mt={["16px", "16px", "20px"]}
            >
                {isDrSmileBrandOnly ? (
                    <Icon
                        w={["100px", "100px", "150px"]}
                        h="auto"
                        as={DrSmileLogo}
                    />
                ) : (
                    <Icon
                        w={["200px", "200px", "250px"]}
                        h="auto"
                        as={DrSmileXImpressLogo}
                    />
                )}
            </Container>
            {!isDrSmileBrandOnly && false && (
                <Box background="linear-gradient(90deg, #83AFFF 0%, #2263D9 15.12%, #1E58BF 42.1%, #2263D9 75.44%, #83AFFF 86.19%, #1E58BF 100%)">
                    <Container px={["24px", "24px", 0]}>
                        <Flex
                            h={["44px", "44px", "56px"]}
                            py={["8px", "8px", "25px"]}
                            gap={["6px", "6px", "13px"]}
                            alignItems="center"
                        >
                            <div>
                                <AttentionSignIcon
                                    width={isMobile ? "26px" : "32px"}
                                    height={isMobile ? "26px" : "32px"}
                                />
                            </div>
                            <Text
                                fontSize={["11px", "11px", "18px"]}
                                fontWeight={700}
                                color="base.primary"
                                pr={"24px"}
                            >
                                {title}
                            </Text>
                        </Flex>
                    </Container>
                </Box>
            )}
        </>
    );
};
